<micro-lookup domain="ssh" obj="sshServers" url="/sshs" [key]="sshId"></micro-lookup>
